import React from "react";
import Button from "Components/button/Button";
import WarningBanner from "Components/warningBanner/WarningBanner";
import t, { getAccountTypeTranslation } from "Utils/translation";
import CopyableItem from "Components/CopyableItem/CopyableItem";
import s from "../../delivery.scss";
import { Icon, upload } from "Icons/index";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import cx from "classnames";

const downloadAsCSV = ({ id, config_hostname, username, password, type, description }) => {
  let csv = "ID,hostname,username,password,type,description\n";

  [[id, config_hostname, username, password, type, description]].forEach(function (row) {
    csv += row.map((r) => `"${getAccountTypeTranslation(r) || r}"`).join(",");
    csv += "\n";
  });

  const fileBlob = new Blob([csv], { type: "text/csv" });

  const hiddenElement = document.createElement("a");
  hiddenElement.href = URL.createObjectURL(fileBlob);
  hiddenElement.target = "_blank";

  hiddenElement.download = `qboxmail-delivery-${id}-credentials.csv`;
  hiddenElement.click();
};

const Credentials = ({ stepper, onFormCancel, newUserData, nextStep, formData }) => {
  const history = useHistory();
  const warningTitle =
    formData.plan === "free"
      ? t("delivery.accounts.add.stepRecap.modal.title.free")
      : t("delivery.accounts.add.stepRecap.modal.title.pay");

  const warningInfo =
    formData.plan === "free"
      ? t("delivery.accounts.add.stepRecap.modal.info.free")
      : t("delivery.accounts.add.stepRecap.modal.info.pay");

  return (
    <div className="screenContainer flexAlignCenter">
      <div className="mt-4 w-full max-w-[--form-page-width]">
        <div className="sectionTitle">{t("delivery.accounts.add.stepCredentials.title")}</div>
        <div className="sectionDesc">{t("delivery.accounts.add.stepCredentials.desc")}</div>
        <Button docsKey="deliveryAddAccount" className="btnDocsFP" color="docs" sizeSmall>
          button.docs
        </Button>
      </div>
      <div className="formContainer">
        <div className="w-full pt-8">
          <WarningBanner info title={warningTitle} color="blue" msg={warningInfo} />

          <h2 className="mt-10 mb-4 text-xl font-semibold">{t("delivery.accounts.add.stepCredentials.parameters")}</h2>
          <div className="">
            <CopyableItem title={t("input.label.hostname")} value={newUserData.config_hostname} />
          </div>

          <div className="mt-4">
            <CopyableItem title={t("input.label.username")} value={newUserData.username} />
          </div>
          <div className="mt-4">
            <CopyableItem title={t("input.label.password")} value={newUserData.password} />
          </div>

          <div className={cx(s.shareLink, "mt-8")} onClick={() => downloadAsCSV(newUserData)}>
            <Icon svg={upload} color="accent" width="1rem" height="1rem" />
            <span className={s.shareLink}>{t("delivery.accounts.add.stepCredentials.downloadAsCsv")}</span>
          </div>
        </div>
        <div>
          <div className="mt-9">
            <WarningBanner msg={t("delivery.accounts.add.stepCredentials.warningMsg")} />
          </div>

          <div className="footerFP formFooter">
            <Button color="accent" onClick={() => history.push("/delivery/accounts")}>
            {t("delivery.accounts.add.stepCredentials.parametersSaved")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Credentials;
